/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* down arrow to scroll to featured collection (homepage) */
  const scrollLink = document.querySelector('[data-product-section]');
  const scrollElem = document.querySelector('.index-products');
  if (scrollLink) {
    scrollLink.addEventListener('click', () => {
      scrollElem.scrollIntoView();
    });
  }
  /* down arrow to scroll to featured collection (homepage) */


  /* down arrow to scroll to blog post */
  const scrollLink2 = document.querySelector('[data-next-section]');
  const scrollElem2 = document.querySelector('.article__wrapper');
  if (scrollLink2) {
    scrollLink2.addEventListener('click', () => {
      scrollElem2.scrollIntoView();
    });
  }
  /* down arrow to scroll to blog post */

  
  /* product grid onchange of size variants */
  const variant_pills = document.querySelectorAll('.variant-pill');
  variant_pills.forEach(function(pill) {
    pill.addEventListener("click", function(e) {
      const active = pill.parentElement.querySelector('.is-active');
      active.classList.remove('is-active');
      pill.classList.add('is-active');

      const price = pill.getAttribute('data-price');
      const var_id = pill.getAttribute('data-variant');
      const form = pill.parentElement.nextElementSibling;
      const form_update = form.querySelector('.shopify-product-form');

      form.querySelector('input[name="id"]').value = var_id;
      form.querySelector('span.price-text').innerHTML = price;
    });
  });
  /* product grid onchange of size variants */

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


$(document).ready(function(){

  /* change price on add to cart button on change of subscription options - used Jquery for easier implementation */
  if ($('.product__block--buttons').length) {
    var observer = new MutationObserver(function(e) { 
      const new_price = $('#data-product-price')[0].innerHTML;
      const atc = $('button[data-add-to-cart]');
      const atc_text = atc.attr('data-button-text');
      const atc_text_new = atc_text + ' - ' + new_price;
      atc.find('[data-add-to-cart-text]').text(atc_text_new);
    });
    observer.observe($('#data-product-price')[0], {characterData: true, childList: true});
  }
  /* change price on add to cart button on change of subscription options */


  if ($('.blog-section--ingredients').length) {

    /* custom search on ingredients blog index */
    $('.search-wrap input').on('focus', function() {
      $('.suggested').show();
    });
    $('.search-wrap input').on('focusout', function() {
      $('.suggested').hide();
    });

    $(document).on("keyup", ".search-wrap input", function (e) {
      const val = $(this).val().toLowerCase();
      var titles = $('.article');
      
      $('.article').hide();
      $.each(titles, function() {
        const title = $(this).attr('data-article-title').toLowerCase();
        if(title.includes(val)) {
          $(this).show();
        }
      });
    });
    /* custom search on ingredients blog index */


    /* custom sort by on ingredients blog index */
    $('.sort-dropdown').on('change', function() {
      const val = $(this).find(":selected").val();
      var container = $(".blog-listing");
      if (val == 'sort') {
        var alphabeticallyOrderedDivs = $('.article').sort(function(a, b) {
          return String.prototype.localeCompare.call($(a).data('article-title').toLowerCase(), $(b).data('article-title').toLowerCase());
        });
        container.detach().empty().append(alphabeticallyOrderedDivs);
      } else {
        var alphabeticallyOrderedDivsReverse = $('.article').sort(function(a, b) {
          return String.prototype.localeCompare.call($(b).data('article-title').toLowerCase(), $(a).data('article-title').toLowerCase());
        });
        container.detach().empty().append(alphabeticallyOrderedDivsReverse);
      }
      $('.grid-outer').append(container);
    });    
    /* custom sort by on ingredients blog index */
                           
    
    /* custom filter on ingredients blog index */
    $('.filters-custom-list input[type="checkbox"]').on('click', function() {

      const val = $(this).attr('data-val');
      const name = $(this).attr('data-name');
      var checkboxes = $('.filters-custom-list input[type="checkbox"]');
      var is_checked = false;
      var num = 0;
      
      $.each(checkboxes, function() {
        if($(this).is(':checked')) {
          is_checked = true;
          num = num + 1;
        }
      });

      if($(this).is(':checked')){
        $('.selected-items').append('<div>'+name+'<a href="#" class="remove-filter" data-val="'+name+'" data-item="'+val+'">X</a></div>');
        $('.title-bar span').text('Filters ('+num+')');
      } else {
        $('.remove-filter[data-item="'+val+'"]').parent('div').remove();
        if(is_checked) {
          $('.title-bar span').text('Filters ('+num+')');
        } else {
          $('.article').show();
          $('.title-bar span').text('Filters');
        }
      }

      if(is_checked) {
        // need to loop checkboxes in case of multiple checked items
        $('.article').hide(); // hide all first
        $.each(checkboxes, function() {
          if($(this).is(':checked')) {
            const t_val = $(this).attr('data-val');
            $(".article[data-article-item*='" + t_val + "']").show(); // show only the checked items articles
          }
        });
      } 
    });
    /* custom filter on ingredients blog index */

    
    /* clear all filters on ingredients blog index */
    $('.clear-all').on('click', function(e) {
      e.preventDefault();
      $('.article').show();
      $('.selected-items').empty();
      $('.title-bar span').text('Filters');
      $('.filters-custom-list input[type="checkbox"]').each(function() {
        this.checked = false;
      });
    });
    /* clear all filters on ingredients blog index */


    /* clear selected filter on ingredients blog index */
    $(document).on('click', '.remove-filter', function(e) {
      e.preventDefault();
      const name = $(this).attr('data-item');
      $('.filters-custom-list [data-val="'+name+'"]').prop("checked",false);
      $(this).parent('div').remove();

      var checkboxes = $('.filters-custom-list input[type="checkbox"]');
      var is_checked = false;
      var num = 0;
      
      $.each(checkboxes, function() {
        if($(this).is(':checked')) {
          is_checked = true;
          num = num + 1;
        }
      });

      if(is_checked) {
        // need to loop checkboxes in case of multiple checked items
        $('.article').hide(); // hide all first
        $.each(checkboxes, function() {
          if($(this).is(':checked')) {
            const t_val = $(this).attr('data-val');
            $(".article[data-article-item*='" + t_val + "']").show(); // show only the checked items articles
          }
        });
        $('.title-bar span').text('Filters ('+num+')');
      } else {
        $('.article').show();
        $('.title-bar span').text('Filters');
      }
    });
    /* clear selected filter on ingredients blog index */


    /* open filters drawer on ingredients blog index */
    $('.mobile-filter-sort').on('click', function(e) {
      $('.sidebar-blogs').css('left', 0);
      $('html').addClass('no-scroll');
    });
    /* open filters drawer on ingredients blog index */

    /* close filters drawer on ingredients blog index */
    $('.custom-close-filter').on('click', function(e) {
      $('.sidebar-blogs').css('left', '-100%');
      $('html').removeClass('no-scroll');
    });
    /* close filters drawer on ingredients blog index */
    
  }


  if($('.subscribe-and-save').length) {
    $('.subscribe-add').on('click', function(){
      $('.product-wrap form').removeClass('active');
      $(this).next().addClass('active');
    });

    $('.one-time-radio').on('click', function(){
      var pr = $(this).attr('data-product');

      console.log("pr", pr);
      $('#custom_sellingplan_'+pr+'').val('');
    });

    $('.subscribe-radio').on('click', function(){
      var pr = $(this).attr('data-product');
      var selling_id = $(this).attr('data-selling-id');

      console.log("pr-sub", pr);
      $('#selling_plan_'+pr+'').prop('disabled', false).show();
      $('#custom_sellingplan_'+pr+'').val(selling_id);
      
    });
  }
  
});





